<template>
  <er-card v-loading="loading" class="pg-status-graph">
    <el-row type="flex" slot="header" class="graph-controls">
      <el-col :span="6" :md="4" :lg="4" :xl="6">
        <p class="card-title">{{ $t("Comn_pond_guard") }}</p> </el-col
      >&nbsp;
      <el-col :span="18" :md="20" :lg="20" :xl="18">
        <layout-toolbar class="pg-graph-filter">
          <el-col :span="4" :md="5" :lg="5" :xl="5">
            <er-select
              :key="pondId"
              class="select-pond-guard"
              v-model="selectPG"
              value-key="device_id"
              @change="handleChangeInPg"
              size="mini"
              :placeholder="$t('Ponds_select_pond_quards')"
            >
              <!-- v-if="listPondGuards>1" -->
              <el-option
                v-for="pg in listPondGuards"
                :key="pg.device_code"
                :value="pg"
                :label="pg.device_code"
              ></el-option>
            </er-select>
          </el-col>
          <el-col :span="4" :md="5" :lg="5" :xl="5">
            <er-select
              class="select-graph-data-type"
              :value="dataViewOptions"
              @change="handleCommand"
              size="mini"
            >
              <el-option
                :label="$t('Pond_raw_data')"
                value="Raw Data"
              ></el-option>
              <el-option
                :label="$t('Comn_avrg_data')"
                value="Average Data"
              ></el-option>
            </er-select>
          </el-col>
          <el-col :span="16" :md="12" :lg="12" :xl="12">
            <er-date-picker
              type="datetimerange"
              unlink-panels
              size="mini"
              :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_TIME"
              value-format="yyyy-MM-dd HH:mm"
              popper-class="pg-date-picker"
              v-model="dateRange"
              :default-time="['12:00:00']"
              :start-placeholder="$t('Comm_Start')"
              :end-placeholder="$t('Comn_End')"
              :picker-options="pickerOptions"
              :clearable="false"
              @change="handleValueChange"
            ></er-date-picker>
          </el-col>
        </layout-toolbar>
      </el-col>
    </el-row>
    <el-row :key="$i18n.locale">
      <high-charts
        ref="pond-guard"
        :options="chartOptions"
        constructor-type="stockChart"
      ></high-charts>
    </el-row>
  </er-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import chartMixin from "@/mixins/chartMixin";
import { pgStatusGraphConfig } from "./chartOptions";
export default {
  mixins: [errorHandlerMixin, chartMixin],
  data: function() {
    return {
      sensor_hourly_logs: [],
      dataViewOptions: "Raw Data",
      dateRange: [],
      listPondGuards: [],
      selectPG: undefined,
      loading: false,
      params: {
        from_date: "",
        to_date: "",
        month_of: null,
        week_of: null
      },
      chartOptions: pgStatusGraphConfig,
      yAxisTextKey: []
    };
  },
  computed: {
    ...mapGetters("pondDetails", {
      getArrSelectedPondPGs: "getArrSelectedPondPGs"
    }),
    ...mapGetters("user", {
      getUserId: "getUserId"
    }),
    dataViewOptionsStr() {
      return {
        "Raw Data": "Pond_raw_data",
        "Average Data": "Comn_avrg_data"
      };
    },
    dateFormat() {
      return "YYYY-MM-DD HH:mm";
    },
    pickerOptions() {
      return {
        disabledDate: time => {
          const isSelectedTimeBetweenCultureDate = this.$moment(
            time.getTime()
          ).isBetween(
            this.$lodash
              .cloneDeep(this.getMomentObjArrOfCultureDateRange[0])
              .subtract(1, "days"),
            this.getMomentObjArrOfCultureDateRange[1]
          );
          return !isSelectedTimeBetweenCultureDate;
        },
        shortcuts: [
          { no: 30, unit: "minutes", text: this.$t("last_30minutes") },
          { no: 1, unit: "hours", text: this.$t("last_1hour") },
          { no: 3, unit: "hours", text: this.$t("last_3hours") },
          { no: 6, unit: "hours", text: this.$t("last_6hours") },
          { no: 12, unit: "hours", text: this.$t("last_12hours") },
          { no: 1, unit: "days", text: this.$t("Comn_yesterday") },
          { no: 6, unit: "days", text: this.$t("last_7days") },
          { no: 14, unit: "days", text: this.$t("last_15days") },
          { no: 1, unit: "months", text: this.$t("last_30days") },
          { no: 3, unit: "months", text: this.$t("last_3months") },
          { no: 6, unit: "months", text: this.$t("last_6months") }
        ].map(shortCut => {
          return {
            text: shortCut.text,
            onClick: picker => {
              const end = this.$moment().utcOffset(this.calculatedTimezone);
              const start = this.$moment().utcOffset(this.calculatedTimezone);
              start.subtract(shortCut.no, shortCut.unit);
              picker.$emit(
                "pick",
                [start, end].map(el => el.format("YYYY-MM-DD HH:mm"))
              );
            }
          };
        })
      };
    },
    defaultMomentDtRangeForCurrCulture() {
      return [
        this.$moment()
          .utcOffset(this.calculatedTimezone)
          .subtract(6, "hours"),
        this.$moment().utcOffset(this.calculatedTimezone)
      ];
    }
  },
  methods: {
    ...mapActions("pondDetails", {
      fetchPondGuardData: "fetchPondGuardData",
      fetchPondPGsInCurrCulture: "fetchPondPGsInCurrCulture",
      fetchAquaLabPondGuardData: "fetchAquaLabPondGuardData"
    }),
    initDateRangeWithMomentObj(momentDateArr) {
      const dates = momentDateArr;
      this.$set(this.dateRange, 0, dates[0].format(this.dateFormat));
      this.$set(this.dateRange, 1, dates[1].format(this.dateFormat));
      this.handleValueChange(this.dateRange);
    },
    async initComponent() {
      this.loading = true;
      try {
        await this.fetchPondPGsInCurrCulture({
          pondId: this.pondId,
          params: {
            from_date: this.params.from_date,
            to_data: this.params.to_date
          }
        });
        await this.manageApiCallByUserId();
        this.handleCommand(this.dataViewOptions);
      } catch (err) {
        this.errorMessages(err, true);
        this.listPondGuards = [];
        this.selectPG = undefined;
        this.sensor_hourly_logs = [];
      } finally {
        this.loading = false;
      }
    },
    getAquaLabUsersDevices() {
      const devicesToPond = {
        "5f7cf6bdbf214921efcb520b": [
          {
            device_id: "70B3D5499825AD39",
            device_code: "70B3D5499825AD39",
            manufacture_by: "AQUALAB"
          }
        ],
        "5f7cf6bdbf214921efcb520a": [
          {
            device_id: "70B3D54994B98CFC",
            device_code: "70B3D5499825AD39",
            manufacture_by: "AQUALAB"
          }
        ]
      };
      if (this.getUserId === "5f6a182c0fa44b545871ecb7") {
        return devicesToPond[this.pondId];
      }
      return undefined;
    },
    async manageApiCallByUserId() {
      let pond_guards = this.getArrSelectedPondPGs || [];
      pond_guards = pond_guards.map(x => {
        x.manufacture_by = "ERUVAKA";
        return x;
      });
      const aquaLabPgs = this.getAquaLabUsersDevices();
      if (aquaLabPgs) {
        pond_guards = [...pond_guards, ...aquaLabPgs];
      }
      if (pond_guards.length > 0) {
        this.listPondGuards = pond_guards;
        this.selectPG = this.listPondGuards[0];
        await this.handleFetchPGData(this.selectPG);
        this.initAxisTextKeys("Comn_date_and_time", [
          "Comn_do_ph",
          "",
          "Comn_temperature_c"
        ]);
        this.initChartLang();
      } else {
        this.listPondGuards = [];
        this.selectPG = undefined;
        this.sensor_hourly_logs = [];
      }
    },
    handleFetchPGData: async function(pg) {
      try {
        let response;
        if (pg.manufacture_by === "AQUALAB") {
          response = await this.fetchAquaLabPondGuardData({
            pgId: pg.device_id,
            params: this.params
          });
        } else {
          response = await this.fetchPondGuardData({
            pondId: this.pondId,
            pgId: pg.device_id,
            params: this.params
          });
        }
        this.sensor_hourly_logs = response.pond_guard_data;
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    pondGuardHourly(pondGuardDataDaysWise) {
      const dateHourlyO2 = {};
      const dateHourlyPH = {};
      const dateHourlyTemp = {};
      pondGuardDataDaysWise.forEach(dayData => {
        const timeSlotData = dayData.data;
        // the date from the server side is UTC with time equal to the user timezone
        const date = this.$moment(dayData.date);
        const dateTimeFeed = date;
        [dateHourlyO2, dateHourlyPH, dateHourlyTemp].forEach(x => {
          if (!x[dateTimeFeed.valueOf()]) {
            x[dateTimeFeed.valueOf()] = 0;
          }
        });
        dateHourlyO2[dateTimeFeed.valueOf()] = timeSlotData.dissolved_oxygen;
        dateHourlyPH[dateTimeFeed.valueOf()] = timeSlotData.ph;
        dateHourlyTemp[dateTimeFeed.valueOf()] = timeSlotData.temperature;
      });
      let hourlyO2 = [];
      Object.keys(dateHourlyO2).forEach(key => {
        const o2 = Number(dateHourlyO2[key]);
        if (o2 > 0) {
          hourlyO2.push({
            x: Number(key),
            y: o2
          });
        }
      });
      let hourlyPH = [];
      Object.keys(dateHourlyPH).forEach(key => {
        hourlyPH.push({
          x: Number(key),
          y: Number(dateHourlyPH[key])
        });
      });
      let hourlyTemp = [];
      Object.keys(dateHourlyTemp).forEach(key => {
        const temp = Number(dateHourlyTemp[key]);
        if (temp > 0) {
          hourlyTemp.push({
            x: Number(key),
            y: temp
          });
        }
      });
      hourlyO2 = hourlyO2.sort((a, b) => a.x - b.x);
      hourlyPH = hourlyPH.sort((a, b) => a.x - b.x);
      hourlyTemp = hourlyTemp.sort((a, b) => a.x - b.x);
      return { hourlyO2, hourlyPH, hourlyTemp };
    },
    pondGuardHourlyAvgData: function(pondGuardDataDaysWise, tempDateRange) {
      const groupByHourlyTemp = {};
      const groupByHourlyO2 = {};
      const groupByHourlyPH = {};
      const dateRangeDiff = {};
      pondGuardDataDaysWise.forEach(dayData => {
        const timeSlotData = dayData.data;
        const hours = Number(timeSlotData.time.substr(0, 2));
        const dateTimeFeed = this.$moment(tempDateRange[0].toISOString())
          .utc()
          .startOf("day")
          .add(hours + 1, "hours");
        [
          groupByHourlyTemp,
          groupByHourlyO2,
          groupByHourlyPH,
          dateRangeDiff
        ].forEach(x => {
          if (!x[dateTimeFeed.valueOf()]) {
            x[dateTimeFeed.valueOf()] = 0;
          }
        });
        groupByHourlyTemp[dateTimeFeed.valueOf()] += timeSlotData.temperature;
        groupByHourlyO2[dateTimeFeed.valueOf()] +=
          timeSlotData.dissolved_oxygen;
        groupByHourlyPH[dateTimeFeed.valueOf()] += timeSlotData.ph;
        dateRangeDiff[dateTimeFeed.valueOf()]++;
      });
      Object.keys(groupByHourlyTemp).forEach(key => {
        groupByHourlyTemp[key] = groupByHourlyTemp[key] / dateRangeDiff[key];
        // if(groupCount[key]>0)
        groupByHourlyO2[key] = groupByHourlyO2[key] / dateRangeDiff[key];
        groupByHourlyPH[key] = groupByHourlyPH[key] / dateRangeDiff[key];
      });
      let resultGroupByHourlyTemp = Object.keys(groupByHourlyTemp).map(key => {
        return {
          x: Number(key),
          y: groupByHourlyTemp[key],
          code: pondGuardDataDaysWise.pond_guard_code
        };
      });
      let resultGroupByHourlyO2 = Object.keys(groupByHourlyO2).map(key => {
        return {
          x: Number(key),
          y: groupByHourlyO2[key],
          code: pondGuardDataDaysWise.pond_guard_code
        };
      });
      let resultGroupByHourlyPH = Object.keys(groupByHourlyPH).map(key => {
        return {
          x: Number(key),
          y: groupByHourlyPH[key],
          code: pondGuardDataDaysWise.pond_guard_code
        };
      });
      resultGroupByHourlyTemp = resultGroupByHourlyTemp.sort(
        (a, b) => a.x - b.x
      );
      resultGroupByHourlyO2 = resultGroupByHourlyO2.sort((a, b) => a.x - b.x);
      resultGroupByHourlyPH = resultGroupByHourlyPH.sort((a, b) => a.x - b.x);
      return {
        groupByHourlyTemp: resultGroupByHourlyTemp,
        groupByHourlyO2: resultGroupByHourlyO2,
        groupByHourlyPH: resultGroupByHourlyPH
      };
    },
    handleChangeInPg: async function(pm) {
      this.loading = true;
      await this.handleFetchPGData(pm);
      this.handleCommand(this.dataViewOptions);
      this.loading = false;
    },
    handleValueChange: function(currentSelectedValues) {
      // console.log(event, "hourly");
      // converting YYYY-MM-DD HH:mm strings to utc String
      const timeZoneStr = this.$commonUtils.castTimeZoneInMinsToStr(
        this.calculatedTimezone
      );
      const tempValues = currentSelectedValues.map(x => {
        return x.replace(" ", "T") + ":00.000" + timeZoneStr;
      });
      console.log(tempValues);
      // init from_date , to_date to the user time zone
      let from_date = this.$moment(tempValues[0]).utcOffset(
        this.calculatedTimezone
      );
      let to_date = this.$moment(tempValues[1]).utcOffset(
        this.calculatedTimezone
      );

      if (!this.checkDateWithInCultureRange(from_date)) {
        from_date = this.getMomentObjArrOfCultureDateRange[0];
      }
      if (!this.checkDateWithInCultureRange(to_date)) {
        to_date = this.getMomentObjArrOfCultureDateRange[1];
      }
      this.params.from_date = from_date.format("YYYY-MM-DDTHH:mm:00.000") + "Z";
      this.params.to_date = to_date.format("YYYY-MM-DDTHH:mm:00.000") + "Z";
      this.initComponent();
    },
    generateData() {
      const hourlyO2 = [];
      const hourlyPH = [];
      const hourlyTemp = [];
      for (let i = 0; i < 10000; i++) {
        hourlyO2.push({
          x: this.$moment()
            .add(i, "seconds")
            .toDate(),
          y: Math.random() * 100
        });
        hourlyPH.push({
          x: this.$moment()
            .add(i, "seconds")
            .toDate(),
          y: Math.random() * 100
        });
        hourlyTemp.push({
          x: this.$moment()
            .add(i, "seconds")
            .toDate(),
          y: Math.random() * 100
        });
      }
      return { hourlyO2, hourlyPH, hourlyTemp };
    },
    initChart() {
      let result = {
        hourlyO2: [],
        hourlyPH: [],
        hourlyTemp: []
      };
      let hourlyO2 = [];
      let hourlyPH = [];
      let hourlyTemp = [];
      // where utc is the time in user time zone
      const tempDateRange = [
        this.$moment(this.params.from_date).utc(),
        this.$moment(this.params.to_date).utc()
      ];
      if (this.sensor_hourly_logs.length > 0) {
        if (this.dataViewOptions === "Raw Data") {
          result = this.pondGuardHourly(this.sensor_hourly_logs);
          hourlyO2 = result.hourlyO2;
          hourlyPH = result.hourlyPH;
          hourlyTemp = result.hourlyTemp;
        } else if (this.dataViewOptions === "Average Data") {
          result = this.pondGuardHourlyAvgData(
            this.sensor_hourly_logs,
            tempDateRange
          );
          hourlyO2 = result.groupByHourlyO2;
          hourlyPH = result.groupByHourlyPH;
          hourlyTemp = result.groupByHourlyTemp;
        }
      }
      this.initChartSeries(hourlyO2, hourlyPH, hourlyTemp);
    },
    initChartSeries(hourlyO2, hourlyPH, hourlyTemp) {
      this.chartOptions.series = [];
      if (hourlyO2.length > 0 || hourlyPH.length > 0 || hourlyTemp.length > 0) {
        const nameObj = series_name => ({
          series_name,
          device_code: this.sensor_hourly_logs[0].pond_guard_code,
          device_code_text: this.$t("Comn_device_id")
        });
        this.chartOptions.series.push({
          name: nameObj(this.$t("PM_dissolved_oxygen_mgl")),
          data: hourlyO2,
          color: "#66CD00",
          type: "line",
          pointWidth: 10,
          visible: true,
          zones: [
            {
              className: "low-do",
              value: "2.5",
              color: "#FF0000"
            },
            {
              className: "medium-do",
              value: "4",
              color: "#7cb5ec"
            }
          ]
        });
        this.chartOptions.series.push({
          name: nameObj(this.$t("Comn_ph")),
          data: hourlyPH,
          type: "line",
          yAxis: 1,
          pointWidth: 10,
          color: "#FFA500",
          visible: false
        });
        this.chartOptions.series.push({
          name: nameObj(this.$t("Comn_temperature_c")),
          data: hourlyTemp,
          type: "line",
          yAxis: 2,
          pointWidth: 10,
          color: "#4572A7",
          visible: true
        });
      }
    },
    setAxisText() {
      this.chartOptions.xAxis.title.text = this.$t(this.xAxisTextKey);
      this.chartOptions.yAxis[0].title.text = this.$t(this.yAxisTextKey[0]);
      this.chartOptions.yAxis[1].title.text = this.$t(this.yAxisTextKey[1]);
      this.chartOptions.yAxis[2].title.text = this.$t(this.yAxisTextKey[2]);
    },
    handleCommand(command) {
      this.dataViewOptions = command;
      this.initChart();
    }
  }
};
</script>
<style lang="scss">
.pg-status-graph {
  .graph-controls {
    align-items: center;
  }
  .pg-graph-filter {
    .el-range-editor--mini .el-range-separator {
      width: 6%;
    }
    .el-select {
      .el-input__inner {
        // padding: 0px 10px;
      }
      .el-input--suffix .el-input__inner {
        padding-right: 20px;
      }
      .el-input__icon {
        width: 15px;
      }
    }
  }
}
</style>
